import React, {useState, useMemo, useEffect} from "react";
import {Form, useFormikContext} from "formik";
import {useTranslation} from "react-i18next";
import {Switch} from "antd";
//local
import {FieldInput} from "../../../components/Field";
import {Button} from "components/buttons/Button";
import {InputsCode} from "components/InputsCode";
import {TERMS_AND_CONDITIONS} from "../../../constants/documents.consts";

export const SettingsForm = ({
  values,
  buttonName,
  setFieldValue,
  isValidData,
  usedEmail,
  onEmailBlur,
}) => {
  const {t} = useTranslation();
  const {handleBlur, validateForm} = useFormikContext();

  const [ifChecked, setIfChecked] = useState(false);
  const isValidCode = useMemo(() => values.code.every(Boolean), [values.code]);

  // the answer about the email comes after the field was left, so the error is shown then
  useEffect(() => {
    usedEmail && validateForm();
  }, [usedEmail, validateForm]);

  return (
    <Form className="settings-form">
      <FieldInput
        type="text"
        name="firstName"
        placeholder={"LOGIN_PLACEHOLDER_FIRST_NAME"}
        label={"LOGIN_FIRST_NAME"}
        errorName="firstName"
        autoFocus
      />
      <FieldInput
        name="lastName"
        placeholder={"LOGIN_PLACEHOLDER_LAST_NAME"}
        label={"LOGIN_LAST_NAME"}
        errorName="lastName"
      />
      <FieldInput
        type="email"
        name="email"
        placeholder={"LOGIN_PLACEHOLDER_EMAIL"}
        label={"E_MAIL"}
        errorName="email"
        onBlur={(e) => {
          handleBlur(e);
          onEmailBlur(e.target.value);
        }}
      />
      <FieldInput
        name="companyNumber"
        mask="999999-9999"
        maskChar="x"
        placeholder="xxxxxx-xxxx"
        label={"LOGIN_ORG_NUMBER"}
        errorName="companyNumber"
        onChange={(e) => {
          const value = e.target.value || "";
          setFieldValue("companyNumber", value);
        }}
      />

      <FieldInput
        name="companyName"
        placeholder={"LOGIN_PLACEHOLDER_COMPANY_NAME"}
        label={"LOGIN_COMPANY_NAME"}
        errorName="companyName"
      />

      <div className="custom-control custom-switch">
        <Switch className="custom-switch-check" onChange={setIfChecked} />
        <p>
          {t("LOGIN_AGREE_FIRST")}
          <a href={TERMS_AND_CONDITIONS} target="__blank">
            {t("LOGIN_AGREE_LINK")}
          </a>
          {t("LOGIN_AGREE_LAST")}
        </p>
      </div>

      {isValidData && (
        <div className="df-column-center mb-8">
          <p className="mt-2">{t("AUTH_CODE_MODAL_TEXT")}</p>
          <InputsCode
            code={values.code}
            setCode={(code) => setFieldValue("code", code)}
            addClass="mt-1 mb-1"
          />
        </div>
      )}

      <Button
        type="submit"
        name={buttonName}
        addClass="settings-form__btn"
        disabled={!ifChecked || (isValidData && !isValidCode)}
      />

      <div className="df-column-center">
        <h4 className="mb-0">{t("LOGIN_PAGE_SUPPORT_HEADER")}</h4>
        <a
          href={`${t("LOGIN_PAGE_SUPPORT_LINK_URL")}`}
          className="cta"
          target="_BLANK"
          rel="noreferrer"
        >
          {t("LOGIN_PAGE_SUPPORT_LINK_TEXT")}
        </a>
      </div>
    </Form>
  );
};
